import { AfterViewInit, Component, signal } from '@angular/core';
import { Router } from '@angular/router';
import 'jquery-slimscroll';
import { AppInformationService, AuthService, UtilityService } from '../../core/core.module';

declare var jQuery: any;

@Component({
    selector: 'app-navigation',
    templateUrl: 'navigation.template.html',
    standalone: false,
})
export class NavigationComponent implements AfterViewInit {
    constructor(private router: Router, public auth: AuthService, public appInfo: AppInformationService, public utility: UtilityService) {}

    async ngOnInit() {}

    ngAfterViewInit() {
        jQuery('#side-menu').metisMenu();

        if (jQuery('body').hasClass('fixed-sidebar')) {
            jQuery('.sidebar-collapse').slimscroll({
                height: '100%',
            });
        }
    }

    activeRoute(routename: string): boolean {
        return this.router.url.indexOf(routename) > -1;
    }

    hasRole(role) {
        return this.auth.hasRole(role);
    }

    showAdmin() {
        return this.auth.hasRole('Administrator');
    }
    canSeeSalesEntry() {
        return this.auth.currentUser?.userName === 'mreimink';
    }

    showDealers() {
        return this.auth.hasRole('Dealers') || this.auth.hasRole('Dealers:Admin');
    }
    showDelivery() {
        return this.auth.hasRole('Delivery') || this.auth.hasRole('Delivery:Admin');
    }
    showBuildSchedule() {
        return this.auth.hasRole('BuildSchedule') || this.auth.hasRole('BuildSchedule:Admin');
    }
    showVendors() {
        return this.auth.hasRole('Vendors') || this.auth.hasRole('Vendors:Admin');
    }

    showContactLog() {
        return this.auth.hasRole('ContactLog') || this.auth.hasRole('ContactLog:Admin');
    }

    showOverviews() {
        return this.auth.hasRole('Administrator');
    }

    showReports() {
        return this.auth.hasRole('Reports');
    }

    showSales() {
        return this.auth.hasRole('Sales');
    }

    showSalesOrders() {
        return this.auth.hasRole('Orders') || this.auth.hasRole('Administrator');
    }

    showBuildAssembly() {
        return this.auth.hasRole('BuildAssembly') || this.auth.hasRole('BuildAssembly:Admin') || this.auth.hasRole('Administrator');
    }

    showConfirmations() {
        return this.auth.hasRole('Confirmations');
    }

    showStatusReview() {
        return this.auth.hasRole('StatusReview');
    }

    showInvoices() {
        return this.auth.hasRole('Invoices') || this.auth.hasRole('Administrator');
    }

    showPayments() {
        return this.auth.hasRole('Payments') || this.auth.hasRole('Payments:Admin') || this.auth.hasRole('Administrator');
    }
    showMobilePictures() {
        return this.auth.hasRole('Mobile:Pictures');
    }
    showMobileStacks() {
        return this.auth.hasRole('Mobile:Stacks');
    }
    showPictures() {
        return this.auth.hasRole('Pictures') || this.auth.hasRole('Pictures:Admin');
    }

    showPurchaseOrders() {
        return this.auth.hasRole('PurchaseOrders') || this.auth.hasRole('Administrator');
    }

    showParts() {
        return this.auth.hasRole('Parts') || this.auth.hasRole('Parts:Admin') || this.auth.hasRole('Administrator');
    }
    showPartsInventory() {
        return this.auth.hasRole('Parts:Inventory') || this.auth.hasRole('Parts:Admin') || this.auth.hasRole('Administrator');
    }
    showPartCost() {
        return this.auth.hasRole('Parts:Admin');
    }
    showPartsBulkEdit() {
        return this.auth.hasRole('Parts:Admin') || this.auth.hasRole('Administrator');
    }

    showWeldShop() {
        return this.auth.hasRole('Administrator') || this.auth.hasRole('WeldShop');
    }

    showExpenseReports() {
        return this.auth.hasRole('Administrator');
    }

    showPartConfigs() {
        return this.auth.hasRole('PartConfig:Admin');
    }
    showProjections() {
        return this.auth.hasRole('Projections:Admin') || this.auth.hasRole('Projections');
    }
    showPricing() {
        return this.auth.hasRole('Parts:PricingAdmin');
    }
}
